import { C_AMBER, rgba } from '../utils/palette';
import { setupCanvas } from '../utils/canvas';
import { YEARS } from '../utils/constants';

export const CHART_KEY = [
    'Rounds competed per rider per year · top 30 riders',
    'Darker cell = deeper round reached',
    'Tap a cell for rider and round detail',
];

/**
 * @param {HTMLCanvasElement} canvas
 * @param {HTMLElement} tooltip
 * @param {Array} riders
 */
export function renderActivityHeatmap(canvas, tooltip, riders) {
    if (!canvas || !riders.length) return;
    const top30 = riders.slice(0, 30);

    const w    = canvas.parentElement.clientWidth || 280;
    const rowH = 11;
    const h    = top30.length * rowH + 16;
    const ctx  = setupCanvas(canvas, w, h);
    ctx.clearRect(0, 0, w, h);

    const allPts = top30.flatMap(r => YEARS.map(yr => r.pointsByYear?.[yr] || 0)).filter(v => v > 0);
    const maxPts = allPts.length ? Math.max(...allPts) : 1;

    const pad   = { left: 4, right: 4 };
    const yearW = (w - pad.left - pad.right) / YEARS.length;

    YEARS.forEach((yr, yi) => {
        ctx.fillStyle = '#bbb';
        ctx.font = '8px monospace';
        ctx.textAlign = 'center';
        ctx.fillText(yr, pad.left + yi * yearW + yearW / 2, 9);
    });

    const cells = [];
    top30.forEach((rider, ri) => {
        YEARS.forEach((yr, yi) => {
            const pts = rider.pointsByYear?.[yr] || 0;
            ctx.fillStyle = pts > 0 ? rgba(C_AMBER, 0.08 + (pts / maxPts) * 0.82) : rgba('#888', 0.06);
            const cx = pad.left + yi * yearW + 1;
            const cy = 12 + ri * rowH;
            ctx.fillRect(cx, cy, yearW - 2, rowH - 1);
            cells.push({ x: cx, y: cy, w: yearW - 2, h: rowH - 1, name: rider.rider, pos: rider.position, yr, pts });
        });
    });

    if (canvas._actMM) canvas.removeEventListener('mousemove',  canvas._actMM);
    if (canvas._actML) canvas.removeEventListener('mouseleave', canvas._actML);
    canvas._actMM = (e) => {
        const rect = canvas.getBoundingClientRect();
        const mx   = e.clientX - rect.left;
        const my   = e.clientY - rect.top;
        const hit  = cells.find(c => mx >= c.x && mx < c.x + c.w && my >= c.y && my < c.y + c.h);
        if (hit && tooltip) {
            tooltip.innerHTML     = `<span class="font-semibold">${hit.pos} ${hit.name}</span> &nbsp; ${hit.yr} &nbsp; <span class="text-neutral-300">${hit.pts > 0 ? hit.pts.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' pts' : '—'}</span>`;
            tooltip.style.display = 'block';
            const _tw1 = tooltip.offsetWidth;
            tooltip.style.left    = (mx + 10 + _tw1 > canvas.parentElement.clientWidth ? mx - _tw1 - 10 : mx + 10) + 'px';
            tooltip.style.top     = (my - 28) + 'px';
        } else if (tooltip) {
            tooltip.style.display = 'none';
        }
    };
    canvas._actML = () => { if (tooltip) tooltip.style.display = 'none'; };
    canvas.addEventListener('mousemove',  canvas._actMM);
    canvas.addEventListener('mouseleave', canvas._actML);
}
